"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _moment = _interopRequireDefault(require("moment"));
var _ykbUtils = require("ykb-utils");
var _Helpers = require("../Helpers");
var isCheckFilteredValue = function isCheckFilteredValue(original, columnId, filterValues) {
  if ((0, _ykbUtils.isNullOrUndefined)(original[columnId])) return false;
  var _filterValues = (0, _slicedToArray2.default)(filterValues, 5),
    type = _filterValues[0],
    props = _filterValues[1],
    columnDef = _filterValues[2],
    min = _filterValues[3],
    max = _filterValues[4];
  var dateFormat = 'DD.MM.YYYY';
  var nowVal = '12.12.1990';
  var selectedFormat = _Helpers.Utils.getDateFormat(columnDef);
  var value = original[columnId];
  var dateValue = "".concat(nowVal, " ").concat(value);
  var fullFormat = "".concat(dateFormat, " ").concat(selectedFormat);
  var maxDate = "".concat(nowVal, " ").concat(max);
  var minDate = "".concat(nowVal, " ").concat(min);

  // A [ indicates inclusion of a value.
  // A ( indicates exclusion. If the inclusivity parameter is used, both indicators must be passed.
  var checkedDate = (0, _moment.default)(dateValue, fullFormat).isBetween(minDate, maxDate, undefined, '[]');
  return checkedDate;
};
var timeFilter = function timeFilter(row, filterValues) {
  var _filterValues2 = (0, _slicedToArray2.default)(filterValues, 3),
    _ = _filterValues2[0],
    props = _filterValues2[1],
    column = _filterValues2[2];
  var filteredValue = column.filteredValue || column.dataIndex;
  var exist = isCheckFilteredValue(row, filteredValue, filterValues);
  // let nestedExist = false;
  // if (!exist && Array.isArray(row.original.children)) {
  //   const list = Utils.flatten(row.original.children);
  //   nestedExist = list.some(item =>
  //     isCheckFilteredValue(item, filteredValue, filterValues)
  //   );
  // }

  // const isExpanded = row.getIsExpanded();
  // const returnVal = exist || nestedExist;
  // if (returnVal && !isExpanded) {
  //   const handleExpand = row.getToggleExpandedHandler();
  //   handleExpand();

  //   const filterData = Object.assign(row.original, { rowId: row.id });
  //   props?.onExpandByFilter(filterData);
  // }
  return exist;
};
var _default = exports.default = timeFilter;